import React, { Component, Fragment } from "react";
import commonFunction from "../../../lib/utils/common";
import { newsLetterSubscription } from "../../../../shared/lib/newsSubscription";
import { emailValidation } from "../../../../common/lib/utils/regex_cheat_sheet";
import configUrl from "../../../../config/config.json";
import Link from "../../../Link";

class Footer12 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      color: "red",
      emailId: "",
      linksData: [],
      emailError: "",
      toast: "",
      success: "",
    };
  }

  onChangeEmail = (data) => {
    const email = data.target.value;

    this.setState({
      emailId: email,
      success:'',
      error:'',
      emailError:
        email && !emailValidation.test(email) ? "Please enter a valid email address." : "",
    });
  };

  getSiteId() {
    return this.props?.data?.site_id;
  }

  getAccessToken() {
    return this.props?.siteData?.data?.access_token;
  }

  handleSubscribe = (e) => {
    e.preventDefault();
    const { emailId } = this.state;


    const site_id = this.getSiteId();
    const accessToken = this.getAccessToken();
    if (!emailId) {
      this.setState({ error: 'Email address is required.' });
      return;
    }

    if (!emailId || !emailValidation.test(emailId)) {
      this.setState({ error: 'Please enter a valid email address.' });
      return;
    }

    const data = {
      accessToken,
      email: emailId,
      site_id,
    };

    newsLetterSubscription(data).then((res) => {
      if (res?.data?.status) {
        this.setState({ emailId: '', error: '', success: 'You have successfully subscribed to the newsletter.' });
      } else if (res?.data?.error?.details) {
        this.setState({ error: res?.data?.error?.details, success: '' });
      } else {
        this.setState({ error: 'Subscription failed. Please try again.', success: '' });
      }
    }).catch(() => {
      this.setState({ error: 'Subscription failed. Please try again.' });
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!this.state.emailId) {
      this.setState({ emailError: "Please enter valid email id" });
      return;
    }

    if (!emailRegex.test(this.state.emailId)) {
      this.setState({ emailError: "Please enter valid email id" });
      return;
    }

    // Handle successful submission
    // alert("Thank you for subscribing!");
    this.setState({ emailId: "", emailError: "", toast: "success" });
  };
  componentDidMount() {
    if (
      !commonFunction.isValueEmpty(this.props) &&
      !commonFunction.isValueEmpty(this.props.data)
    ) {
      if (
        !commonFunction.isValueEmpty(this.props.data.footermenu) &&
        !commonFunction.isValueEmpty(this.props.data.footermenu.menu)
      ) {
        this.setState({ linksData: this.props?.data?.footermenu?.menu });
      }
    }
  }

  render() {
    let downloadAppWidget = {};
    if (localStorage.getItem("appType") == "mobileapp") {
      downloadAppWidget = { display: "none" };
    }
    const pathname = window.location.pathname;
    const validPaths = ['/activity/details','/activity/success','/activity/booking'].includes(pathname);
    return (
      <>
        {this.props.data.isMobile  ? (
          !validPaths?
          <footer className={this.props?.data?.cssfile?.site_footer}>
            <div className={this.props?.data?.cssfile?.container}>
              <div className={this.props?.data?.cssfile?.footer_top}>
                <div className={this.props?.data?.cssfile?.footer_contact}>
                  <img src="/images/call_footer.svg" alt="" />
                  <span>Speak to our expert</span>
                  <a
                    href={`tel:${this.props?.data?.siteData?.site?.support_number}`}
                    className={this.props?.data?.cssfile?.phone_number}
                  >
                    {this.props?.data?.siteData?.site?.support_number}
                  </a>
                </div>
                <hr className={this.props?.data?.cssfile?.footer_divider} />
                <nav className={this.props?.data?.cssfile?.footer_links}>
                  <ul>
                    {this.props?.data?.footermenu?.mobile?.menu?.length > 0 &&
                      this.props?.data?.footermenu?.mobile?.menu
                        ?.slice(0, 6)
                        ?.map((item, index) => {
                          return (
                            <li key={index}>
                              <a href={item?.url}>{item?.text}</a>
                            </li>
                          );
                        })}
                  </ul>
                </nav>
              </div>
              <hr className={this.props?.data?.cssfile?.footer_divider} />
              <div className={this.props?.data?.cssfile?.social_flex}>
                <div className={this.props?.data?.cssfile?.footer_social_new}>
                  <span className={this.props?.data?.cssfile?.footer_title}>
                    Follow us
                  </span>
                  <div className={this.props?.data?.cssfile?.social_links}>
                    {this.props?.data?.footermenu?.mobile?.socialmedia?.map(
                      (item, index) => {
                        return (
                          <a
                            href={item?.url}
                            key={index}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${"/shared/api/media/" +
                                this.props?.data?.siteData?.site.id +
                                "/" +
                                `${item?.icon}`
                                }`}
                              // src={`/images/${item?.icon}`}
                              alt={item?.text}
                            />
                          </a>
                        );
                      }
                    )}
                    {/* <a href="#">
                      <img src="/images/instagram_footer.svg" alt="Instagram" />
                    </a>
                    <a href="#">
                      <img src="/images/facebook_footer.svg" alt="Facebook" />
                    </a>
                    <a href="#">
                      <img src="/images/x_footer.svg" alt="X" />
                    </a> */}
                  </div>
                </div>

                {/* <div style={{
                  visibility: 'hidden',
                  display: this.props.data.isMobile ? 'none' : 'block'
                }} */}
                <div
                  className={this.props?.data?.cssfile?.footer_apps}>
                  <span className={this.props?.data?.cssfile?.footer_title}>
                    Mobile Apps
                  </span>
                  <div className={this.props?.data?.cssfile?.footer_social_new}>
                    <a href="https://onelink.to/bbpro-app" className={this.props?.data?.cssfile?.app_link}>
                      <img src="/images/apple_footer.svg" alt="Apple Logo" />
                      <span>iOS App</span>
                    </a>
                    <a href="https://onelink.to/bbpro-app" className={this.props?.data?.cssfile?.app_link}>
                      {/* merged image */}
                      <div
                        className={
                          this.props?.data?.cssfile?.android_icon_wrapper
                        }
                      >
                        <img
                          src="/images/playstore_footer.svg"
                          alt=""
                          className={
                            this.props?.data?.cssfile?.android_icon_part1
                          }
                        />
                        <img
                          src="/images/I18347_10583_17580_5848.svg"
                          alt=""
                          className={
                            this.props?.data?.cssfile?.android_icon_part2
                          }
                        />
                      </div>
                      <span>Android App</span>
                    </a>
                  </div>
                </div>
              </div>
              <hr className={this.props?.data?.cssfile?.footer_divider} />
              <div className={this.props?.data?.cssfile?.footer_main}>
                {/* <div className={this.props?.data?.cssfile?.footer_about}>
                <img
                  src="images/aaad8fb9e320ce0cf4f6ace4cdf9a126c24f9587.png"
                  alt="Booking Bash Logo"
                  className={this.props?.data?.cssfile?.footer_logo}
                />
                <p>
                  We are always on the hunt for the best deals for all sort of
                  experiences and attractions in the city. Add BookingBash in your
                  bookmarks and check with us weekly for the best deals in town
                </p>
              </div> */}


                {/* <div style={{
                  visibility: 'hidden',
                  display: this.props.data.isMobile ? 'none' : 'block'
                }} */}

              
                <div
                  className={this.props?.data?.cssfile?.footer_newsletter}>
                  <h4>Newsletter</h4>
                  <p>Subscribe to the newsletter and stay up to date</p>
                  <form
                    className={this.props?.data?.cssfile?.newsletter_form}
                    onSubmit={this.handleSubscribe}
                  >
                    <input
                      type="email"
                      placeholder="Enter your email id"
                      value={this.state.emailId}
                      onChange={this.onChangeEmail}

                    />
                    <button type="submit">Send</button>
                  </form>
                  {this.state.success && (
                    <div className={this.props?.data?.cssfile?.success_message}>
                      <span> {this.state.success}</span>
                    </div>
                  )}
                  {this.state.error && (
                    <div className={this.props?.data?.cssfile?.error_message}>
                      <span> {this.state.error}</span>
                    </div>
                  )}
                </div>

                <div
                  class={`${this.props?.data?.cssfile?.site_footer} ${this.props?.data?.cssfile?.site_footer_mob}`}
                >
                  <div class={this.props?.data?.cssfile?.footer_links_text}>
                  <p className={this.props?.data?.cssfile?.legal_links_text}>
                    {this.props?.data?.footermenu?.mobile?.menu?.length > 6 &&
                      this.props?.data?.footermenu?.mobile?.menu
                        ?.slice(6, 8)
                        ?.map((item, index, array) => (
                          <span key={index}>
                            <a href={item?.url}>
                              {item?.text}
                              {index < array.length - 1 && " | "}
                            </a>
                          </span>
                        ))}
                  </p>
                  </div>
                  <p class={this.props?.data?.cssfile?.copyright_text}>
                    {this.props?.data?.footermenu?.mobile?.text}
                  </p>
                </div>
              </div>
              {/* <div className={this.props?.data?.cssfile?.footer_bottom}>
                <div className={this.props?.data?.cssfile?.footer_legal}>
                <span>Â© The Bookingbash 2025. All Rights Reserved.</span>
                <a href="#">Terms & Conditions</a>
                <a href="#">Privacy Policy</a>
              </div>
              </div> */}
            </div>
            {this.state.toast === "success" ? (
              <div>
                Subscription successful! You'll now get our latest updates and
                tips.
              </div>
            ) : this.state.toast === "fail" ? (
              <div>This email address is already subscribed.</div>
            ) : null}
          </footer>:<div className={this.props?.data?.cssfile?.site_footer}></div>
        ) : (
          // Desktop view start

          <footer className={this.props?.data?.cssfile?.site_footer}>
            <div className={this.props?.data?.cssfile?.container}>
              <div className={this.props?.data?.cssfile?.footer_top}>
                <div className={this.props?.data?.cssfile?.footer_top_flex}>
                  <div className={this.props?.data?.cssfile?.footer_contact}>
                    <img src="/images/call_footer.svg" alt="" />
                    <span>Speak to our expert</span>
                    <a
                      href={`tel:${this.props?.data?.siteData?.site?.support_number}`}
                      className={this.props?.data?.cssfile?.phone_number}
                    >
                      {this.props?.data?.siteData?.site?.support_number}
                    </a>
                  </div>

                  <div className={this.props?.data?.cssfile?.social_flex}>
                    <div
                      className={`${this.props?.data?.cssfile?.footer_social_new} ${this.props?.data?.cssfile?.footer_social_new_left}`}
                    >
                      <span
                        className={this.props?.data?.cssfile?.footer_title}
                      >
                        Follow us
                      </span>
                      <div
                        className={`${this.props?.data?.cssfile?.social_links}`}
                      >
                        {this.props?.data?.footermenu?.socialmedia?.map(
                          (item, index) => {
                            return (
                              <a
                                href={item?.url}
                                key={index}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={`${"/shared/api/media/" +
                                    this.props?.data?.siteData?.site.id +
                                    "/" +
                                    `${item?.icon}`
                                    }`}
                                  // src={`/images/${item?.icon}`}
                                  alt={item?.text}
                                />
                              </a>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr className={this.props?.data?.cssfile?.footer_divider} />

              <div className={this.props?.data?.cssfile?.footer_grid}>
                <div className={this.props?.data?.cssfile?.footer_about}>
                  <img
                    src={`${"/shared/api/media/" +
                      this.props?.data?.siteData?.site.id +
                      "/" +
                      this.props?.data?.footermenu?.logo
                      }`}
                    alt="Booking Bash Logo"
                    className={this.props?.data?.cssfile?.footer_logo}
                  />
                  <p>
                    We are always on the hunt for the best deals for all sort
                    of experiences and attractions in the city. Add
                    BookingBash in your bookmarks and check with us weekly for
                    the best deals in town
                  </p>
                </div>

                <nav
                  className={`${this.props?.data?.cssfile?.footer_links} ${this.props?.data?.cssfile?.footer_links_grid}`}
                >
                  <ul>
                    {this.props?.data?.footermenu?.menu?.length > 0 &&
                      this.props?.data?.footermenu?.menu?.slice(0, -2)
                        ?.slice(0, 6)
                        ?.map((item, index) => {
                          return (
                            <li key={index}>
                              <a href={item?.url}>{item?.text}</a>
                            </li>
                          );
                        })}
                  </ul>
                </nav>

                {/* <div style={{
                  visibility: 'hidden',
                  display: this.props.data.isMobile ? 'none' : 'block'
                }} */}

                <div
                  className={this.props?.data?.cssfile?.footer_newsletter}>
                  <h4>Newsletter</h4>
                  <p>Subscribe to the newsletter and stay up to date</p>
                  <form
                    className={this.props?.data?.cssfile?.newsletter_form}
                    onSubmit={this.handleSubscribe}
                  >
                    <input
                      type="email"
                      placeholder="Enter your email id"
                      value={this.state.emailId}
                      onChange={this.onChangeEmail}
                    />
                    <button type="submit">Send</button>
                  </form>
                  {this.state.success && (
                    <div className={this.props?.data?.cssfile?.success_message}>
                      <span> {this.state.success}</span>
                    </div>
                  )}

                  {this.state.error && (
                    <div className={this.props?.data?.cssfile?.error_message}>
                      <span>{this.state.error}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className={this.props?.data?.cssfile?.footer_main_desk}>
                <div className={this.props?.data?.cssfile?.site_footer_desk}>
                  <p className={this.props?.data?.cssfile?.copyright_text}>
                    {this.props?.data?.footermenu?.text}
                  </p>
                  <div
                    className={this.props?.data?.cssfile?.footer_links_text}
                  >
                    {
                      this.props?.data?.footermenu?.menu
                        ?.slice(-2)
                        ?.map((item, index) => {
                          return (
                            <span key={index}>
                              <a
                                href={item?.url}
                                target={
                                  item?.text == "policy" ? "_blank" : "_self"
                                }
                              >
                                {item?.text} {index < 1 && "|"}{" "}
                              </a>
                            </span>
                          );
                        })}
                  </div>
                </div>
                {/* <div style={{
                  visibility: 'hidden',
                  display: this.props.data.isMobile ? 'none' : 'block'
                   }} */}
                <div
                  className={this.props?.data?.cssfile?.footer_apps}>
                  <span className={this.props?.data?.cssfile?.footer_title}>
                    Mobile Apps
                  </span>
                  <div
                    className={this.props?.data?.cssfile?.footer_social_new}
                  >
                    <a
                      href="https://onelink.to/bbpro-app"
                      className={this.props?.data?.cssfile?.app_link}
                    >
                      <img src="/images/apple_footer.svg" alt="Apple Logo" />
                      <span>iOS App</span>
                    </a>
                    <a
                      href="https://onelink.to/bbpro-app"
                      className={this.props?.data?.cssfile?.app_link}
                    >
                      {/* merged image */}
                      <div
                        className={
                          this.props?.data?.cssfile?.android_icon_wrapper
                        }
                      >
                        <img
                          src="/images/playstore_footer.svg"
                          alt=""
                          className={
                            this.props?.data?.cssfile?.android_icon_part1
                          }
                        />
                        <img
                          src="/images/playstore_footer.svg"
                          alt=""
                          className={
                            this.props?.data?.cssfile?.android_icon_part2
                          }
                        />
                      </div>
                      <span>Android App</span>
                    </a>
                  </div>
                </div>
              </div>
              {/* <div className={this.props?.data?.cssfile?.footer_bottom}>
                  <div className={this.props?.data?.cssfile?.footer_legal}>
                    <span>Â© The Bookingbash 2025. All Rights Reserved.</span>
                    <a href="#">Terms & Conditions</a>
                    <a href="#">Privacy Policy</a>
                  </div> 
                </div> */}
            </div>

            {this.state.toast === "success" ? (
              <div>
                Subscription successful! You'll now get our latest updates
                and tips.
              </div>
            ) : this.state.toast === "fail" ? (
              <div>This email address is already subscribed.</div>
            ) : null}
          </footer>
        )}
      </>
    );
  }
}

export default Footer12;
